import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isUnbound } from 'owa-linkedin';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AppsOption: LazyOption = createLazyOption(
    {
        key: 'appAccess',
        titleStringKey: 'optionTitle_app_access',
        searchTermsStringKey: 'optionTitle_app_access',
        isHidden: () => !isFeatureEnabled('auth-linkedInOption') || isUnbound(),
    },
    lazyFullModule,
    m => m.default
);
export default AppsOption;
